<template>
  <div class="myview">
    <details-modal
      :show="modals.canton"
      :current-operation="currentOperation"
      @cancel="closeModal"
      @create="createRecord"
      @delete="deleteRecord"
      @update="updateRecord"
    >
      <form>
        <fg-input v-model="canton.name" type="text" label="Nom" />
        <fg-input
          v-model="canton.code"
          :disabled="!(currentOperation === 'create')"
          type="text"
          label="Code"
        />
      </form>
      <p class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          ref="crudList"
          :fetch-data="fetchCantons"
          title="Cantons"
          @create="create"
          @row-clicked="rowClicked"
        >
          <el-table-column label="Nom">
            <div slot-scope="slotScope">{{ slotScope.row.name }}&nbsp;</div>
          </el-table-column>
          <el-table-column label="Code" min-width="20">
            <div slot-scope="slotScope">{{ slotScope.row.code }}&nbsp;</div>
          </el-table-column>
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsModal from './Modals/DetailsModal.vue';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
    DetailsModal,
  },
  data() {
    return {
      modals: {
        canton: false,
      },
      currentOperation: {},
      canton: {},
      errorMessage: '',
    };
  },
  methods: {
    rowClicked(row) {
      this.currentOperation = 'edit';
      this.canton = { ...row };
      this.modals.canton = true;
    },
    fetchCantons(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;
      if (searchText) {
        url += `/cantonEntities/search/fulltext?name=${searchText}&code=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/cantonEntities?page=${pageNumber - 1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.cantonEntities
          ? response.data._embedded.cantonEntities
          : [],
        page: response.data.page,
      }));
    },
    deleteRecord() {
      this.errorMessage = 'Deleting...';
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/cantons/${this.canton.code}`,
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.canton = false;
        })
        .catch(error => {
          this.errorMessage = error.response.data.message;
        });
    },
    updateRecord() {
      this.errorMessage = 'Updating...';
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/cantons/${this.canton.code}`,
          {
            code: this.canton.code,
            name: this.canton.name,
          },
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.canton = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    createRecord() {
      this.$http
        .post(`${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/cantons/`, {
          code: this.canton.code,
          name: this.canton.name,
        })
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.canton = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    create() {
      this.canton = {};
      this.currentOperation = 'create';
      this.modals.canton = true;
    },
    closeModal() {
      this.modals.canton = false;
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped></style>
